import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Button from "@/atomic/atoms/Button";
import { InputMask } from "@react-input/mask";
import { Link } from "react-router-dom";

const fieldClass = (hasError?: boolean, extra?: string) =>
  `mt-3 text-base text-black bg-transparent border p-2 rounded-xl h-14 ${extra ?? "w-full"} ${
    hasError
      ? "border-red-500"
      : "border-gray-200 [&:not(:placeholder-shown)]:border [&:not(:placeholder-shown)]:border-black"
  }`;

export default function RegisterView({
  goBack,
  isDisabled,
  activeStep,
  goToNextStep,
  jumpSteps,
  goToBeforeStep,
  errors,
  register,
  handleSubmit,
  watch,
  setValue,
  switchPersonType,
  isPJEnabled,
}: PropsView) {
  const { isAcceptedTerms, personType } = watch();
  

  const toggleTerms = () => setValue("isAcceptedTerms", !isAcceptedTerms);

  return (
    <div className="h-full relative">
      <Header
        title="Dados Pessoais"
        hasLeftButton
        goBack={goBack}
      />
      <main className="py-2 px-5 w-full flex justify-center h-[calc(100%-72px)] h-form bg-background">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={handleSubmit}>
          <div className="overflow-y-auto pb-4">
            <h2 className="mt-6 text-black text-[28px] leading-tight font-bold">Que tal se apresentar<br />pra gente?</h2>

            {isPJEnabled && (
              <div className="flex mt-4 gap-2">
                <button
                  type="button"
                  onClick={() => switchPersonType("fisica")}
                  className={`flex-1 h-12 rounded-xl border text-sm font-medium transition-colors ${
                    personType === "fisica"
                      ? "border-primary text-black bg-white"
                      : "border-gray-200 text-gray-400 bg-white"
                  }`}
                >
                  Pessoa física
                </button>
                <button
                  type="button"
                  onClick={() => switchPersonType("juridica")}
                  className={`flex-1 h-12 rounded-xl border text-sm font-medium transition-colors ${
                    personType === "juridica"
                      ? "border-primary text-black bg-white"
                      : "border-gray-200 text-gray-400 bg-white"
                  }`}
                >
                  Pessoa jurídica
                </button>
              </div>
            )}

            {(!isPJEnabled || personType === "fisica") ? (
              <div className="flex flex-col justify-center mt-1">
                <input
                  {...register("name")}
                  type="text"
                  placeholder="Nome completo*"
                  className={fieldClass(!!errors.name)}
                />
                {errors.name && (
                  <span className="text-red-500 text-xs">{errors.name.message as string}</span>
                )}
                <InputMask
                  {...register("document")}
                  key="document-fisica"
                  type="text"
                  inputMode="numeric"
                  mask="___.___.___-__"
                  replacement={{ _: /\d/ }}
                  placeholder="CPF*"
                  className={fieldClass(!!errors.document)}
                />
                {errors.document && (
                  <span className="text-red-500 text-xs">{errors.document.message as string}</span>
                )}
                <InputMask
                  {...register("phone")}
                  type="text"
                  inputMode="numeric"
                  mask="(__) _____-____"
                  replacement={{ _: /\d/ }}
                  placeholder="Telefone*"
                  className={fieldClass(!!errors.phone)}
                />
                {errors.phone && (
                  <span className="text-red-500 text-xs">{errors.phone.message as string}</span>
                )}
                <input
                  {...register("email")}
                  type="text"
                  placeholder="E-mail*"
                  className={fieldClass(!!errors.email)}
                />
                {errors.email && (
                  <span className="text-red-500 text-xs">{errors.email.message as string}</span>
                )}
              </div>
            ) : (
              <div className="flex flex-col justify-center mt-1">
                <input
                  {...register("name")}
                  type="text"
                  placeholder="Nome fantasia*"
                  className={fieldClass(!!errors.name)}
                />
                {errors.name && (
                  <span className="text-red-500 text-xs">{errors.name.message as string}</span>
                )}
                <InputMask
                  {...register("document")}
                  key="document-juridica"
                  type="text"
                  inputMode="numeric"
                  mask="__.___.___/____-__"
                  replacement={{ _: /\d/ }}
                  placeholder="CNPJ*"
                  className={fieldClass(!!errors.document)}
                />
                {errors.document && (
                  <span className="text-red-500 text-xs">{errors.document.message as string}</span>
                )}
                <input
                  {...register("razaoSocial")}
                  type="text"
                  placeholder="Razão social*"
                  className={fieldClass(!!errors.razaoSocial)}
                />
                {errors.razaoSocial && (
                  <span className="text-red-500 text-xs">{errors.razaoSocial.message as string}</span>
                )}
                <InputMask
                  {...register("phone")}
                  type="text"
                  inputMode="numeric"
                  mask="(__) _____-____"
                  replacement={{ _: /\d/ }}
                  placeholder="Telefone*"
                  className={fieldClass(!!errors.phone)}
                />
                {errors.phone && (
                  <span className="text-red-500 text-xs">{errors.phone.message as string}</span>
                )}
                <input
                  {...register("email")}
                  type="text"
                  placeholder="E-mail*"
                  className={fieldClass(!!errors.email)}
                />
                {errors.email && (
                  <span className="text-red-500 text-xs">{errors.email.message as string}</span>
                )}
                <InputMask
                  {...register("birthdate")}
                  type="text"
                  inputMode="numeric"
                  mask="__/__/____"
                  replacement={{ _: /\d/ }}
                  placeholder="Data da abertura*"
                  className={fieldClass(!!errors.birthdate)}
                />
                {errors.birthdate && (
                  <span className="text-red-500 text-xs">{errors.birthdate.message as string}</span>
                )}
              </div>
            )}

            <div className="flex flex-col items-start justify-start mt-4 w-full">
              <label className="flex items-center cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={isAcceptedTerms}
                  onChange={toggleTerms}
                  className="w-5 h-5 accent-black mr-2 rounded"
                />
                <div className="flex flex-1">
                  <span className="text-sm text-black">
                    Aceito os <Link to="/terms" className="underline text-gray-500">Termos de Uso</Link> e <Link to="/policy" className="underline text-gray-500">Política de Privacidade</Link>
                  </span>
                </div>
              </label>
              {errors.isAcceptedTerms && (
                <span className="text-red-500 text-xs">{errors.isAcceptedTerms.message as string}</span>
              )}
            </div>
          </div>
          <Button
            className="rounded-xl bg-primary text-white"
            title="Continuar"
            type="submit"
            isDisabled={isDisabled}
          />
        </form>
      </main>
      {activeStep < 2 && <div className={`p-8 fixed flex flex-col flex-1 top-0 left-0 right-0 bottom-0 z-30 w-full bg-black justify-between items-start text-black h-full min-h-screen ${activeStep === 0 ? "bg-onboarding1" : "bg-onboarding2"} bg-cover bg-fixed bg-center transition-all duration-500 ease-in-out`}>
        <div className="w-full md:max-w-7xl md:mx-auto flex items-center justify-between">
          <button onClick={goToBeforeStep} className="text-white">
            <img
              src="/icon-arrow-left-white.png"
              height={24}
              width={24}
            />
          </button>
          <button onClick={jumpSteps} className="text-white">
            Pular
          </button>
        </div>
        <div className="w-full md:max-w-7xl md:mx-auto mb-[calc(80px)]">
          <div className="max-w-md">
            {activeStep === 0 && <h1 className="text-white text-3xl md:text-4xl mb-1 transition-all duration-300 ease-in-out font-bold">Siga viagem sem  <br/>perrengue, <span className="text-secondary">sem parar<br/></span></h1>}
            {activeStep !== 0 && <h1 className="text-white text-3xl md:text-4xl mb-1 transition-all duration-300 ease-in-out font-bold">Pegue a estrada, <span className="text-secondary">pague <br /> o pedágio no automático.</span></h1>}
            {activeStep === 0 && <h2 className="text-white text-lg md:text-xl mb-9 transition-all duration-300 ease-in-out mt-3 font-myFont">Consulta e gerenciamento de passagens pra você viver sua rotina com tranquilidade.</h2>}
            {activeStep !== 0 && <h2 className="text-white text-lg md:text-xl mb-9 transition-all duration-300 ease-in-out mt-3 font-myFont">Cobrança direto no cartão cadastrado. Rápido, seguro e sem surpresas.</h2>}
          </div>
          <div className="flex w-full items-end justify-between">
            <div className="flex items-center justify-start">
              <span
                className={activeStep === 0 ? "bg-white h-2 w-4 rounded-lg" : "bg-gray-400 h-2 w-2 rounded-lg"}
              />
              <span
                className={`ml-1 ${activeStep === 0 ? "bg-gray-400 h-2 w-2 rounded-lg" : "bg-white h-2 w-4 rounded-lg"}`}
              />
            </div>
            <button
              className="border border-white rounded-lg p-4 px-6 text-white"
              onClick={goToNextStep}>
              Próximo
            </button>
          </div>
        </div>
      </div>}
    </div>
  );
}
